export default {
  elapsedThresholds: {
    fail: 360000,
    warning: 180000
  }
}
